/*
 * @Description: 文件内容
 * @Author: 陈威达
 * @Date: 2022-11-11 10:05:27
 * @LastEditors: 陈威达
 * @LastEditTime: 2023-06-15 18:44:18
 */
import React, { useState, useEffect } from 'react'
import styles from './standard.scss'
import product from '../../../common/images/product/product-9.jpg'
import { useParams } from 'react-router-dom'
import User from '@/modules/user'

const Standard = (props) => {
  const params = useParams()
  const [data, setData] = useState({})
  const id = params.id
  const user = new User()
  const getDetails = () => {
    user.getArticleID(id)
      .then(res => {
        // 财税服务机构\n客户运营/发票采集/智能记账\n个税申报/国税全税种申报
        res.digest = res.digest && res.digest.includes('\\n') ? res.digest.split('\\n') : [res.digest]
        setData(res)
      })
      .catch((res) => {
        setData({})
        console.log(res)
      })
  }
  useEffect(() => {
    getDetails()
  }, [id])
  return <section className={styles['standard']}>
    <div className={styles['advanced-contnet']}>
      <div className={styles['product']}>
        <img src={product} alt='product' />
        <div>
          <h3>概而论云记账</h3>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['characters']}>
        <h2>{data.articleName}</h2>
        <div>
          <p><span>适用群体</span></p>
          {data.digest && data.digest.length > 0 && data.digest.map(item => {
            return <p key={item} className={styles['tip-content']}>{item}</p>
          })}
        </div>
      </div>
      <div className={styles['advanced-yd']}>
        <p><span>适用群体</span></p>
        {data.digest && data.digest.length > 0 && data.digest.map(item => {
          return <p key={item} className={styles['tip-content']}>{item}</p>
        })}
      </div>
      <div className={styles['advanced-table']}>
        <div dangerouslySetInnerHTML = {{ __html: data.docContext }}></div>
      </div>
    </div>
  </section>
}

export default Standard
